import React, { useState, useEffect } from "react";
import APIService from "../../Service/APIService";
import Swal from "sweetalert2";
import Text from "../../common/typography/text";
import CommonButton from "../../common/button/button";
import ModalView from "../../common/modal";
import TextInput from "../../common/text-input";
import DropdownComponent from "../../common/dropdown-input";
import RowIcon from "../../common/row-icon";
import ProductGroupCards from "./ProductGroupCards";
import QuickList from "../../common/list-component/quick-list";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Flex } from "antd";
import { colors } from "../../theme/colors.js";
import { useNavigate } from "react-router-dom";
import OpenOrderImageUpload from "./OpenOrderImageUpload";
import SectionHeader from "../../common/section-header/index.js";

const YES_NO_OPTIONS = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

const SHIPPING_TYPE_OPTIONS = [
  { label: "Standard Rates", value: "standard" },
  { label: "Custom Rates", value: "custom" },
  { label: "FedEx Live Rates", value: "fedex" },
];

const toBooleanValue = (option) => option?.value === "yes";
const boolValue = (value) => value === true || value === "true" || value === 1 || value === "1";
const normalizeInvoicePrefixInput = (value) =>
  value == null ? null : String(value).slice(0, 200);

const buildProductGroupRequestPayload = (payload, imageFile, removeImage) => {
  if (!imageFile && !removeImage) return payload;

  const formData = new FormData();
  formData.append("payload", JSON.stringify(payload));
  if (imageFile) formData.append("openOrderImage", imageFile);
  if (removeImage) formData.append("removeOpenOrderImage", "true");
  return formData;
};

const ManufacturerProduct = (props) => {
  const navigate = useNavigate();
  const { manufacturerData, canEditManufacturer = false } = props;
  const manufacturerAllowsPayment = boolValue(manufacturerData?.ASInvoice);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false); // add product
  const [modalOpenAddProductGroup, setModalOpenAddProductGroup] =
    useState(false); // add product group
  const [productGroups, setProductGroups] = useState([]);
  const [productsAdded, setProductsAdded] = useState([
    { ProductName: "", ProductCode: "", Units: "", StandardPrice: "" },
  ]);

  // form values
  const [productGroupName, setProductGroupName] = useState(null);
  const [productGroupCategory, setProductGroupCategory] = useState(null);
  const [productGroupRate, setProductGroupRate] = useState(null);
  const [productGroupInvoicePrefix, setProductGroupInvoicePrefix] = useState(null);
  const [productGroupQCode, setProductGroupQCode] = useState(null);
  const [productGroupSerialized, setProductGroupSerialized] = useState(null);
  const [productGroupIVR, setProductGroupIVR] = useState(null);
  const [productGroupRequireProcedureInfo, setProductGroupRequireProcedureInfo] =
    useState(null);
  const [
    productGroupSignatureRequiredForDelivery,
    setProductGroupSignatureRequiredForDelivery,
  ] = useState(null);
  const [productGroupCollectPayment, setProductGroupCollectPayment] =
    useState(null);
  const [productGroupEnableOpenOrder, setProductGroupEnableOpenOrder] =
    useState(null);
  const [productGroupEnableCommissionContract, setProductGroupEnableCommissionContract] =
    useState(YES_NO_OPTIONS[1]);
  const [productGroupOpenOrderImageFile, setProductGroupOpenOrderImageFile] =
    useState(null);
  const [productGroupShippingType, setProductGroupShippingType] =
    useState(SHIPPING_TYPE_OPTIONS[0]);
  const [productGroupShippingCategory, setProductGroupShippingCategory] =
    useState(null);
  const [standardPrice, setStandardPrice] = useState(0);

  const [productGroupNameEdit, setProductGroupNameEdit] = useState(null);
  const [productGroupRateEdit, setProductGroupRateEdit] = useState(null);
  const [productGroupInvoicePrefixEdit, setProductGroupInvoicePrefixEdit] =
    useState(null);
  const [productGroupQCodeEdit, setProductGroupQCodeEdit] = useState(null);
  const [productGroupSerializedEdit, setProductGroupSerializedEdit] =
    useState(null);
  const [productGroupIVREdit, setProductGroupIVREdit] = useState(null);
  const [
    productGroupRequireProcedureInfoEdit,
    setProductGroupRequireProcedureInfoEdit,
  ] = useState(null);
  const [
    productGroupSignatureRequiredForDeliveryEdit,
    setProductGroupSignatureRequiredForDeliveryEdit,
  ] = useState(null);
  const [productGroupCollectPaymentEdit, setProductGroupCollectPaymentEdit] =
    useState(null);
  const [productGroupEnableOpenOrderEdit, setProductGroupEnableOpenOrderEdit] =
    useState(null);
  const [productGroupOpenOrderImageFileEdit, setProductGroupOpenOrderImageFileEdit] =
    useState(null);
  const [removeProductGroupOpenOrderImageEdit, setRemoveProductGroupOpenOrderImageEdit] =
    useState(false);
  const [productGroupShippingTypeEdit, setProductGroupShippingTypeEdit] =
    useState(SHIPPING_TYPE_OPTIONS[0]);
  const [productGroupShippingCategoryEdit, setProductGroupShippingCategoryEdit] =
    useState(null);
  const [productGroupStatusEdit, setProductGroupStatusEdit] = useState();
  const [standardPriceEdit, setStandardPriceEdit] = useState(0);
  const [shippingCategoryOptions, setShippingCategoryOptions] = useState([]);
  const [productGroupCategoryOptions, setProductGroupCategoryOptions] =
    useState([]);
  const [isProductGroupCategoriesLoading, setIsProductGroupCategoriesLoading] =
    useState(false);
  const [isShippingCategoriesLoading, setIsShippingCategoriesLoading] =
    useState(false);

  useEffect(() => {
    if (manufacturerAllowsPayment) return;
    setProductGroupCollectPayment(YES_NO_OPTIONS[1]);
    setProductGroupEnableOpenOrder(YES_NO_OPTIONS[1]);
    setProductGroupCollectPaymentEdit(YES_NO_OPTIONS[1]);
    setProductGroupEnableOpenOrderEdit(YES_NO_OPTIONS[1]);
  }, [manufacturerAllowsPayment]);

  // generic dashboard
  const [showProductGroupView, setShowProductGroupView] = useState(false);
  const [showProductGroupEdit, setShowProductGroupEdit] = useState(false);
  const [productGroupData, setProductGroupData] = useState(null);
  const [productsUnderGroup, setProductsUnderGroup] = useState([
    { ProductName: "", ProductCode: "", Units: "", StandardPrice: "" },
  ]);
  const [isLoadingProducts, setIsLoadingProducts] = useState(false);

  const resetAddProductGroupForm = () => {
    setProductGroupName(null);
    setProductGroupCategory(null);
    setProductGroupRate(null);
    setProductGroupInvoicePrefix(null);
    setProductGroupQCode(null);
    setProductGroupSerialized(null);
    setProductGroupIVR(null);
    setProductGroupRequireProcedureInfo(null);
    setProductGroupSignatureRequiredForDelivery(null);
    setProductGroupCollectPayment(
      manufacturerAllowsPayment ? null : YES_NO_OPTIONS[1]
    );
    setProductGroupEnableOpenOrder(
      manufacturerAllowsPayment ? null : YES_NO_OPTIONS[1]
    );
    setProductGroupEnableCommissionContract(YES_NO_OPTIONS[1]);
    setProductGroupOpenOrderImageFile(null);
    setProductGroupShippingType(SHIPPING_TYPE_OPTIONS[0]);
    setProductGroupShippingCategory(null);
    setProductsAdded([
      { ProductName: "", ProductCode: "", Units: "", StandardPrice: "" },
    ]);
    setStandardPrice(0);
  };

  const openAddProductGroupModal = () => {
    if (!canEditManufacturer) return;
    resetAddProductGroupForm();
    setModalOpenAddProductGroup(true);
  };

  const closeAddProductGroupModal = () => {
    setModalOpenAddProductGroup(false);
    resetAddProductGroupForm();
  };

  const closeEditProductGroupModal = () => {
    setShowProductGroupEdit(false);
    setProductGroupData(null);
    setProductGroupInvoicePrefixEdit(null);
    setProductGroupRequireProcedureInfoEdit(null);
    setProductGroupSignatureRequiredForDeliveryEdit(null);
    setProductGroupEnableOpenOrderEdit(null);
    setProductGroupOpenOrderImageFileEdit(null);
    setRemoveProductGroupOpenOrderImageEdit(false);
    setProductGroupShippingCategoryEdit(null);
    setProductGroupShippingTypeEdit(SHIPPING_TYPE_OPTIONS[0]);
  };

  const getShippingCategoryPlaceholder = () => {
    if (isShippingCategoriesLoading) return "Loading shipping categories";
    if (!shippingCategoryOptions.length) return "No shipping categories available";
    return "Shipping Category";
  };

  const getProductGroupCategoryPlaceholder = () => {
    if (isProductGroupCategoriesLoading) {
      return "Loading Product Group categories";
    }
    if (!productGroupCategoryOptions.length) {
      return "No Product Group categories available";
    }
    return "Choose a Product Group category";
  };

  const isShippingCategoryRequired = (shippingType, shippingCategory) =>
    shippingType?.value === "custom" && !shippingCategory?.value;

  const handleOpenOrderImageSelect = (file, { isEdit = false } = {}) => {
    if (!file) return;
    if (isEdit) {
      setProductGroupOpenOrderImageFileEdit(file);
      setRemoveProductGroupOpenOrderImageEdit(false);
    } else {
      setProductGroupOpenOrderImageFile(file);
    }
  };

  const clearAddOpenOrderImage = () => {
    setProductGroupOpenOrderImageFile(null);
  };

  const removeEditOpenOrderImage = () => {
    setProductGroupOpenOrderImageFileEdit(null);
    setRemoveProductGroupOpenOrderImageEdit(false);
  };

  const getShippingCategoryOption = (shippingCategoryID, shippingCategoryName) => {
    const matched = shippingCategoryOptions.find(
      (option) => Number(option.value) === Number(shippingCategoryID)
    );
    if (matched) return matched;
    if (!shippingCategoryID || Number(shippingCategoryID) <= 0) return null;
    return {
      label: shippingCategoryName,
      value: Number(shippingCategoryID),
    };
  };

  const handleEditManufacturerProductGroupModal = (row) => {
    if (!canEditManufacturer) return;
    navigate(`/Manufacturer/${manufacturerData?.ID}/ProductGroup/${row?.ID}`);
  };

  const handleViewManufacturerProductGroupModal = (row) => {
    console.log(row);
    setShowProductGroupView(true);
    setProductGroupData(row);
  };

  const getProductsByProductGroupID = async () => {
    setIsLoadingProducts(true);
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getproductsbyproductgroupid/?ProductGroupID=${productGroupData?.ID}`
    );
    console.log("Products from Manufacturer: ", response?.data?.data);
    setProductsUnderGroup(
      response?.data?.data.filter((item) => item?.IsActive === true)
    );

    setIsLoadingProducts(false);
  };

  const getProductsFromManufacturer = async () => {
    const apiServe = new APIService();
    console.log("Manufacturer-Product Data: ", manufacturerData);
    const response = await apiServe.getDataFromBackend(
      `getproductsfrommanufacturer/?ID=${manufacturerData?.ID}`
    );
    console.log("Products from Manufacturer: ", response?.data?.data);
    setProducts(response?.data?.data);
  };

  const getProductGroups = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `GetProductGroupsByManufacturerID?ManufacturerID=${manufacturerData?.ID}`
    );
    const newData = response?.data?.data.map((item, index) => ({
      ...item,
      key: index + 1,
      CommissionPercentage:
        item.CommissionPercentage === null ||
        item.CommissionPercentage === undefined
          ? 0
          : item.CommissionPercentage,
    }));
    console.log("Product Groups: ", newData);
    setProductGroups(newData);
  };

  const getShippingCategoryOptions = async () => {
    setIsShippingCategoriesLoading(true);
    const apiServe = new APIService();
    try {
      const response = await apiServe.getDataFromBackend("getshippingcategoryoptions");
      const options = (response?.data?.data || []).map((item) => ({
        label: item?.ShippingCategoryName,
        value: item?.ID,
      }));
      setShippingCategoryOptions(options);
    } catch (error) {
      console.error("Failed to load shipping category options", error);
      setShippingCategoryOptions([]);
    } finally {
      setIsShippingCategoriesLoading(false);
    }
  };

  const getProductGroupCategoryOptions = async () => {
    setIsProductGroupCategoriesLoading(true);
    const apiServe = new APIService();
    try {
      const response = await apiServe.getDataFromBackend(
        "product-group-categories"
      );
      const options = (
        response?.data?.data?.ProductGroupCategories || []
      ).map((item) => ({
        label: item?.Category,
        value: Number(item?.ID),
      }));
      setProductGroupCategoryOptions(options);
    } catch (error) {
      console.error("Failed to load Product Group category options", error);
      setProductGroupCategoryOptions([]);
    } finally {
      setIsProductGroupCategoriesLoading(false);
    }
  };

  const submitAddProductGroupHandler = async (type) => {
    if (
      !productGroupName ||
      !productGroupCategory?.value ||
      !productGroupRate ||
      !productGroupSerialized ||
      !productGroupIVR ||
      !productGroupRequireProcedureInfo ||
      !productGroupSignatureRequiredForDelivery ||
      !productGroupCollectPayment ||
      !productGroupEnableOpenOrder ||
      !productGroupEnableCommissionContract ||
      isShippingCategoryRequired(
        productGroupShippingType,
        productGroupShippingCategory
      )
    ) {
      Swal.fire({
        icon: "error",
        title: "Missing Required Fields",
        text: productGroupShippingType?.value === "custom"
          ? "Please complete all required product group fields, including Shipping Category, before saving."
          : "Please complete all required product group fields before saving.",
      });
      return;
    }

    if (
      toBooleanValue(productGroupCollectPayment) &&
      !manufacturerAllowsPayment
    ) {
      Swal.fire({
        icon: "error",
        title: "AS Invoice Required",
        text: "Collect Payment can only be enabled for an AS Invoice manufacturer.",
      });
      return;
    }

    if (
      toBooleanValue(productGroupEnableOpenOrder) &&
      !toBooleanValue(productGroupCollectPayment)
    ) {
      Swal.fire({
        icon: "error",
        title: "Collect Payment Required",
        text: "Collect Payment must be enabled before enabling Open Order.",
      });
      return;
    }

    console.log(productsAdded);
    const addProductGroupObj = {
      ProductGroup: {
        ProductGroupName: productGroupName,
        ProductGroupCategoryID: productGroupCategory.value,
        Rate: productGroupRate,
        InvoicePrefix: productGroupInvoicePrefix,
        QCode: productGroupQCode,
        Serialized: toBooleanValue(productGroupSerialized),
        IVR: toBooleanValue(productGroupIVR),
        RequireProcedureInfo: toBooleanValue(productGroupRequireProcedureInfo),
        SignatureRequiredForDelivery: toBooleanValue(
          productGroupSignatureRequiredForDelivery
        ),
        CollectPayment: toBooleanValue(productGroupCollectPayment),
        EnableOpenOrder: toBooleanValue(productGroupEnableOpenOrder),
        EnableCommissionContract: toBooleanValue(productGroupEnableCommissionContract),
        CustomShipping: productGroupShippingType?.value === "custom",
        UseFedexShipping: productGroupShippingType?.value === "fedex",
        ShippingCategoryID: productGroupShippingType?.value === "custom"
          ? productGroupShippingCategory?.value
          : 0,
        ManufacturerID: manufacturerData?.ID,
        ManufacturerName: manufacturerData?.ManufacturerName,
      },
      Products: productsAdded,
    };
    console.log(addProductGroupObj);
    const apiServe = new APIService();
    Swal.fire({
      title: "Are you sure?",
      text: "You want to add this product group?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["successColor"],
      cancelButtonColor: colors["failureColor"],
      confirmButtonText: "Save",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        console.log("Post Object:", addProductGroupObj);
        const requestPayload = buildProductGroupRequestPayload(
          addProductGroupObj,
          productGroupOpenOrderImageFile,
          false
        );
        const endpoint = "CreateProductGroup?type=" + (type ?? "");
        const response = productGroupOpenOrderImageFile
          ? await apiServe.addFileDataToBackend(requestPayload, endpoint, {
              headers: { "Content-Type": "multipart/form-data" },
            })
          : await apiServe.addDataToBackend(requestPayload, endpoint);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire(
            "Saved Changes!",
            "Product Group has been added.",
            "success"
          ).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error has occurred",
          }).then(() => {
            // window.location.reload();
            setLoading(false);
          });
          setLoading(false);
        }
        // console.log("Add Product Group Response: ", response);
        // Swal.fire("Added!", "Product Group has been added.", "success").then(
        //   () => {
        //     window.location.reload();
        //   }
        // );
      }
    });
  };

  const submitEditProductGroupHandler = async (type) => {
    if (
      !productGroupNameEdit ||
      !productGroupRateEdit ||
      !productGroupSerializedEdit ||
      !productGroupIVREdit ||
      !productGroupRequireProcedureInfoEdit ||
      !productGroupSignatureRequiredForDeliveryEdit ||
      !productGroupCollectPaymentEdit ||
      !productGroupEnableOpenOrderEdit ||
      !productGroupStatusEdit ||
      isShippingCategoryRequired(
        productGroupShippingTypeEdit,
        productGroupShippingCategoryEdit
      )
    ) {
      Swal.fire({
        icon: "error",
        title: "Missing Required Fields",
        text: productGroupShippingTypeEdit?.value === "custom"
          ? "Please complete all required product group fields, including Shipping Category, before saving."
          : "Please complete all required product group fields before saving.",
      });
      return;
    }

    if (
      toBooleanValue(productGroupCollectPaymentEdit) &&
      !manufacturerAllowsPayment
    ) {
      Swal.fire({
        icon: "error",
        title: "AS Invoice Required",
        text: "Collect Payment can only be enabled for an AS Invoice manufacturer.",
      });
      return;
    }

    if (
      toBooleanValue(productGroupEnableOpenOrderEdit) &&
      !toBooleanValue(productGroupCollectPaymentEdit)
    ) {
      Swal.fire({
        icon: "error",
        title: "Collect Payment Required",
        text: "Collect Payment must be enabled before enabling Open Order.",
      });
      return;
    }

    const editProductGroupObj = {
      ProductGroup: {
        ID: productGroupData?.ID,
        IsActive: productGroupStatusEdit?.label === "Active" ? true : false,
        ProductGroupName: productGroupNameEdit,
        Rate: productGroupRateEdit,
        InvoicePrefix: productGroupInvoicePrefixEdit,
        QCode: productGroupQCodeEdit,
        Serialized: toBooleanValue(productGroupSerializedEdit),
        IVR: toBooleanValue(productGroupIVREdit),
        RequireProcedureInfo: toBooleanValue(
          productGroupRequireProcedureInfoEdit
        ),
        SignatureRequiredForDelivery: toBooleanValue(
          productGroupSignatureRequiredForDeliveryEdit
        ),
        CollectPayment: toBooleanValue(productGroupCollectPaymentEdit),
        EnableOpenOrder: toBooleanValue(productGroupEnableOpenOrderEdit),
        CustomShipping: productGroupShippingTypeEdit?.value === "custom",
        UseFedexShipping: productGroupShippingTypeEdit?.value === "fedex",
        ShippingCategoryID: productGroupShippingTypeEdit?.value === "custom"
          ? productGroupShippingCategoryEdit?.value
          : 0,
        ManufacturerID: manufacturerData?.ID,
        ManufacturerName: manufacturerData?.ManufacturerName,
      },
      Products: productsUnderGroup,
    };
    setProductGroups((prev) =>
      prev.map((group) => {
        console.log();
        return group.ID === editProductGroupObj.ProductGroup.ID
          ? editProductGroupObj.ProductGroup
          : group;
      })
    );
    console.log(editProductGroupObj, "editProductGroupObj >>>>1");
    const apiServe = new APIService();
    Swal.fire({
      title: "Save Product Group Changes",
      text: "Are you sure you want to save these changes to the product group? This will affect the product catalog for all associated accounts.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["successColor"],
      cancelButtonColor: colors["failureColor"],
      confirmButtonText: "Save",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        console.log("Post Object:", editProductGroupObj);
        const requestPayload = buildProductGroupRequestPayload(
          editProductGroupObj,
          productGroupOpenOrderImageFileEdit,
          removeProductGroupOpenOrderImageEdit
        );
        const endpoint = "UpdateProductGroup?type=" + (type ?? "");
        const response =
          productGroupOpenOrderImageFileEdit || removeProductGroupOpenOrderImageEdit
            ? await apiServe.addFileDataToBackend(requestPayload, endpoint, {
                headers: { "Content-Type": "multipart/form-data" },
              })
            : await apiServe.addDataToBackend(requestPayload, endpoint);
        console.log(response);
        console.log("Saved Product Group Response: ", response);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire(
            "Saved Changes!",
            "Product Group has been edited.",
            "success"
          ).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error has occurred",
          }).then(() => {
            // window.location.reload();
            setLoading(false);
          });
          setLoading(false);
        }
      }
    });
  };

  React.useEffect(() => {
    console.log("Manufacturer-Product component mounted");
    getProductsFromManufacturer();
    getProductGroups();
    if (canEditManufacturer) {
      getShippingCategoryOptions();
      getProductGroupCategoryOptions();
    }
  }, [manufacturerData, canEditManufacturer]);

  useEffect(() => {
    if (productGroupData && (showProductGroupView || showProductGroupEdit)) {
      setProductsUnderGroup([]);
      getProductsByProductGroupID();
      console.log("here>>>> 1");
      // const productsList = products?.filter((prd) => {
      //   console.log(prd);
      //   console.log(productGroupData?.ID);
      //   return productGroupData?.ID === prd?.ProductGroupID;
      // });
      // console.log(productsList);
      // setProductsUnderGroup(productsList);
    }
  }, [productGroupData?.ID, showProductGroupEdit, showProductGroupView]);

  // const handleProductSubmit = async () => {
  //   // console.log(productsUnderGroup)
  //   // let isValid = true;
  //   // if (!values.ProductCode) {
  //   //   isValid = false;
  //   // }
  //   // if (!values.ProductName) {
  //   //   isValid = false;
  //   // }
  //   // if (!values.StandardPrice) {
  //   //   isValid = false;
  //   // }
  //   // if (!isValid) {
  //   //   Swal.fire({
  //   //     icon: "error",
  //   //     title: "Oops...",
  //   //     text: "Please fill all the fields!",
  //   //   });
  //   //   return;
  //   // }

  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You want to add this product?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: colors["successColor"],
  //     cancelButtonColor: colors["failureColor"],
  //     confirmButtonText: "Yes, add it!",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       console.log("Form values:", values);
  //       const postObj = {
  //         ManufacturerID: manufacturerData?.ID,
  //         ManufacturerName: values.ManufacturerName,
  //         ProductCode: values.ProductCode,
  //         ProductName: values.ProductName,
  //         StandardPrice: values.StandardPrice,
  //       };
  //       console.log("Post Object:", postObj);
  //       // API call to add product
  //       const apiServe = new APIService();
  //       const response = await apiServe.addDataToBackend(postObj, "addproduct");
  //       console.log("AddProduct Response: ", response);
  //       Swal.fire("Added!", "Product has been added.", "success").then(() => {
  //         window.location.reload();
  //       });
  //     }
  //   });
  // };

  const deleteProduct = (index) => {
    console.log(productsUnderGroup[index]);
    console.log(index);
    // console.log("Product Values:", record);
    // return;
    const apiServe = new APIService();
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this product?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await apiServe.updateDataToBackend(
            productsUnderGroup[index],
            "updateproduct?type=delete"
          );
          console.log("Delete response:", response);
          if (response?.status === 200 || response?.status === 201) {
            Swal.fire(
              "Success!",
              "Product Deleted Successfully.",
              "success"
            ).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire("Error!", "Error deleting product.", "error");
          }
        }
      });
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  // const handleStandardPrice = (index) => {
  //   setStandardPrice(productGroupRate * productsAdded[index]?.units);
  // };

  const handleStandardPriceEdit = (index) => {
    console.log(productsUnderGroup[index]?.Units);
    setStandardPrice(productGroupData?.Rate * productsUnderGroup[index]?.Units);
  };

  const handleChange = (index, field, value) => {
    const newProducts = [...productsAdded];
    newProducts[index][field] = value;
    // setStandardPrice(productGroupRate * productsAdded[index]?.Units);
    newProducts[index]["StandardPrice"] =
      productGroupRate * productsAdded[index]?.Units;
    console.log(newProducts);
    setProductsAdded(newProducts);
  };

  const handleChangeEdit = (index, field, value) => {
    const newProducts = [...productsUnderGroup];
    newProducts[index][field] = value;
    newProducts[index]["StandardPrice"] =
      productGroupRateEdit * productsUnderGroup[index]?.Units;
    console.log(newProducts);
    setProductsUnderGroup(newProducts);
  };

  const handleProductGroupRateEdit = (value) => {
    setProductGroupRateEdit(value);
    const updatedProducts = productsUnderGroup.map((product) => ({
      ...product,
      StandardPrice: Number(value) * Number(product.Units || 0),
    }));
    setProductsUnderGroup(updatedProducts);
  };

  const addProduct = () => {
    setProductsAdded([
      ...productsAdded,
      { ProductName: "", ProductCode: "", Units: "", StandardPrice: "" },
    ]);
  };

  const addProductEdit = () => {
    console.log(productsUnderGroup);
    setProductsUnderGroup([
      ...productsUnderGroup,
      { ProductName: "", ProductCode: "", Units: "", StandardPrice: "" },
    ]);

    console.log(productsUnderGroup);
  };

  const handleProductGroupStatus = () => {
    console.log(productGroupStatusEdit, "here >>>> 1");
    setProductGroupStatusEdit(
      productGroupStatusEdit === "active" ? false : true
    );
  };

  const removeProductEdit = (index) => {
    const newProducts = [...productsUnderGroup];
    newProducts.splice(index, 1);
    setProductsUnderGroup(newProducts);
  };

  const removeProduct = (index) => {
    const newProducts = [...productsAdded];
    newProducts.splice(index, 1);
    setProductsAdded(newProducts);
    setStandardPrice(0);
  };

  console.log(productGroups);
  console.log(productsUnderGroup);
  console.log(productGroupStatusEdit);

  return (
    <div>
      {loading && (
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      )}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <SectionHeader
          title="Product Groups"
          showButton={false}
          rightContent={
            canEditManufacturer && (
              <CommonButton onClick={openAddProductGroupModal}>
                Add Product Group
              </CommonButton>
            )
          }
        />

        {products && productGroups && (
          <ProductGroupCards
            productGroups={productGroups}
            canEdit={canEditManufacturer}
            onView={handleViewManufacturerProductGroupModal}
            onEdit={handleEditManufacturerProductGroupModal}
          />
        )}
      </div>

      {/* {userType === "Admin" && (
        <Button
          type="primary"
          onClick={handleAddProduct}
          icon={<PlusOutlined />}
          style={{ background: "#colors["primaryColor"]", marginTop: "16px" }}
        >
          Add Product
        </Button>
      )}

      {modalOpen && (
        <Modal
          title="Add Product"
          open={modalOpen}
          onCancel={handleModalCancel}
          centered={true}
          footer={null}
        >
          <div style={{ padding: "10px 20px 20px 20px" }}>
            <Formik
              initialValues={initialProductValues}
              onSubmit={handleProductSubmit}
              enableReinitialize
            >
              {({ values, handleChange, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Row gutter={16} className="form-row">
                    <Col span={24}>
                      <label
                        htmlFor="ManufacturerName"
                        className="form-input-label"
                      >
                        Manufacturer Name
                      </label>
                      <Input
                        id="ManufacturerName"
                        name="ManufacturerName"
                        value={values.ManufacturerName}
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row gutter={16} className="form-row">
                    <Col span={12}>
                      <label htmlFor="ProductCode" className="form-input-label">
                        Product Code
                      </label>
                      <Input
                        id="ProductCode"
                        name="ProductCode"
                        value={values.ProductCode}
                        onChange={handleChange}
                      />
                    </Col>
                    <Col span={12}>
                      <label
                        htmlFor="StandardPrice"
                        className="form-input-label"
                      >
                        Product Standard Cost
                      </label>
                      <Input
                        id="StandardPrice"
                        name="StandardPrice"
                        value={values.StandardPrice}
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                  <Row gutter={16} className="form-row">
                    <Col span={24}>
                      <label htmlFor="ProductName" className="form-input-label">
                        Product Name
                      </label>
                      <Input
                        id="ProductName"
                        name="ProductName"
                        value={values.ProductName}
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>

                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      background: "#27a907",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                  >
                    Add Product
                  </Button>
                </form>
              )}
            </Formik>
          </div>
        </Modal>
      )} */}

      <ModalView
        isOpen={modalOpenAddProductGroup}
        onClose={closeAddProductGroupModal}
        modalTitle="Add Product Group"
        textInputComponent={
          <div
            style={{ display: "flex", flexDirection: "column", gap: "32px" }}
          >
            <div className="field-group-wrapper">
              <div className="field-group">
                <TextInput
                  titleText="Product Group Name"
                  placeholder="Product Group Name"
                  value={productGroupName}
                  isRequired
                  setValue={setProductGroupName}
                />
                <TextInput
                  titleText="Rate"
                  placeholder="Rate"
                  value={productGroupRate}
                  isRequired
                  setValue={setProductGroupRate}
                />
                <TextInput
                  titleText="Invoice Prefix"
                  placeholder="Invoice Prefix"
                  value={productGroupInvoicePrefix}
                  setValue={(value) =>
                    setProductGroupInvoicePrefix(
                      normalizeInvoicePrefixInput(value)
                    )
                  }
                />
                <TextInput
                  titleText="HCPCS Code"
                  placeholder="HCPCS Code"
                  value={productGroupQCode}
                  setValue={setProductGroupQCode}
                />
                <DropdownComponent
                  label="Choose Product Group Category"
                  placeholder={getProductGroupCategoryPlaceholder()}
                  isRequired
                  isDisabled={
                    isProductGroupCategoriesLoading ||
                    productGroupCategoryOptions.length === 0
                  }
                  options={productGroupCategoryOptions}
                  value={productGroupCategory}
                  setValue={setProductGroupCategory}
                />
              </div>

              <div className="field-group-wrapper">
                <div className="field-group">
                  <DropdownComponent
                    label="Product Group is Serialized"
                    placeholder="Product Group is Serialized"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupSerialized}
                    setValue={setProductGroupSerialized}
                  />
                  <DropdownComponent
                    label="Product Group needs IVR"
                    placeholder="Product Group needs IVR"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupIVR}
                    setValue={setProductGroupIVR}
                  />
                  <DropdownComponent
                    isDisabled={!manufacturerAllowsPayment}
                    label="Collect Payment"
                    placeholder="Collect Payment"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupCollectPayment}
                    setValue={setProductGroupCollectPayment}
                  />
                  <DropdownComponent
                    isDisabled={!manufacturerAllowsPayment}
                    label="Enable Open Order"
                    placeholder="Enable Open Order"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupEnableOpenOrder}
                    setValue={setProductGroupEnableOpenOrder}
                  />
                  <DropdownComponent
                    label="Enable Commission Contract"
                    placeholder="Enable Commission Contract"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupEnableCommissionContract}
                    setValue={setProductGroupEnableCommissionContract}
                  />
                  <DropdownComponent
                    label="Require Procedure Info"
                    placeholder="Require Procedure Info"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupRequireProcedureInfo}
                    setValue={setProductGroupRequireProcedureInfo}
                  />
                  <DropdownComponent
                    label="Signature Required for Delivery"
                    placeholder="Signature Required for Delivery"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupSignatureRequiredForDelivery}
                    setValue={setProductGroupSignatureRequiredForDelivery}
                  />
                </div>
              </div>
            </div>
            <div className="field-group-wrapper">
              <div className="field-group">
                <OpenOrderImageUpload
                  onClear={clearAddOpenOrderImage}
                  onFileSelect={(file) => handleOpenOrderImageSelect(file)}
                  selectedFile={productGroupOpenOrderImageFile}
                />
              </div>
            </div>
            <div className="field-group-wrapper">
              <div className="field-group">
                <DropdownComponent
                  label="Shipping Type"
                  placeholder="Shipping Type"
                  isRequired
                  options={SHIPPING_TYPE_OPTIONS}
                  value={productGroupShippingType}
                  setValue={(option) => {
                    setProductGroupShippingType(option);
                    if (option?.value !== "custom") {
                      setProductGroupShippingCategory(null);
                    }
                  }}
                />
              </div>
              {productGroupShippingType?.value === "custom" && (
                <div className="field-group-wrapper">
                  <div className="field-group">
                    <DropdownComponent
                      label="Shipping Category"
                      placeholder={getShippingCategoryPlaceholder()}
                      isRequired
                      isDisabled={
                        isShippingCategoriesLoading ||
                        shippingCategoryOptions.length === 0
                      }
                      options={shippingCategoryOptions}
                      value={productGroupShippingCategory}
                      setValue={setProductGroupShippingCategory}
                    />
                  </div>
                </div>
              )}
            </div>
            {productsAdded?.map((product, index) => {
              return (
                <div className="field-group-wrapper">
                  <div className="field-group-end">
                    <TextInput
                      titleText="Product Name"
                      placeholder="Product Name"
                      value={product?.ProductName}
                      isRequired
                      onChange={(e) =>
                        handleChange(index, "ProductName", e.target.value)
                      }
                    />
                    <TextInput
                      titleText="Product Code"
                      placeholder="Product Code"
                      value={product?.ProductCode}
                      isRequired
                      onChange={(e) =>
                        handleChange(index, "ProductCode", e.target.value)
                      }
                    />
                    <TextInput
                      titleText="Units"
                      placeholder="Units"
                      value={product?.Units}
                      isRequired
                      onChange={(e) => {
                        handleChange(index, "Units", e.target.value);
                        // handleStandardPrice(
                        //   index,
                        //   "standardPrice",
                        //   e.target.value
                        // );
                        // handleStandardPrice(e.target.value, product, index);
                      }}
                    />
                    <TextInput
                      titleText="Standard Price"
                      placeholder="Standard Price"
                      value={product?.StandardPrice}
                      isRequired
                      isDisabled
                      // onChange={(e) => handleStandardPrice(e, product, index)}
                    />
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => removeProduct(index)}
                    >
                      <RowIcon />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        }
        footerButtonWrapper={
          <div
            style={{ display: "flex", flexDirection: "column", gap: "32px" }}
          >
            <div className="footer-button-wrapper">
              <CommonButton
                variant="table"
                subVariant="primary"
                onClick={addProduct}
                disabled={
                  !(
                    productGroupName &&
                    productGroupCategory?.value &&
                    productGroupRate &&
                    productGroupQCode &&
                    productGroupSerialized &&
                    productGroupIVR &&
                    productGroupRequireProcedureInfo &&
                    productGroupSignatureRequiredForDelivery &&
                    productGroupCollectPayment &&
                    productGroupEnableOpenOrder &&
                    !isShippingCategoryRequired(
                      productGroupShippingType,
                      productGroupShippingCategory
                    )
                  )
                }
              >
                Add Product
              </CommonButton>
            </div>
            <div className="footer-button-wrapper">
              <CommonButton
                variant="table"
                subVariant="success"
                onClick={() => submitAddProductGroupHandler("available")}
              >
                Save and Make Available
              </CommonButton>
              <CommonButton
                variant="table"
                subVariant="success"
                onClick={() => submitAddProductGroupHandler("unavailable")}
              >
                Save and Make Unavailable
              </CommonButton>
            </div>
          </div>
        }
      />

      <ModalView
        isOpen={showProductGroupEdit}
        onClose={closeEditProductGroupModal}
        modalTitle="Edit Product Group"
        textInputComponent={
          <div
            style={{ display: "flex", flexDirection: "column", gap: "32px" }}
          >
            <div className="field-group-wrapper">
              <div className="field-group">
                <TextInput
                  titleText="Product Group Name"
                  placeholder="Product Group Name"
                  value={productGroupNameEdit}
                  isRequired
                  setValue={setProductGroupNameEdit}
                />
                <TextInput
                  titleText="Rate"
                  placeholder="Rate"
                  value={productGroupRateEdit}
                  isRequired
                  onChange={(e) => handleProductGroupRateEdit(e.target.value)}
                />
                <TextInput
                  titleText="Invoice Prefix"
                  placeholder="Invoice Prefix"
                  value={productGroupInvoicePrefixEdit}
                  setValue={(value) =>
                    setProductGroupInvoicePrefixEdit(
                      normalizeInvoicePrefixInput(value)
                    )
                  }
                />
                <TextInput
                  titleText="HCPCS Code"
                  placeholder="HCPCS Code"
                  value={productGroupQCodeEdit}
                  setValue={setProductGroupQCodeEdit}
                />
              </div>

              <div className="field-group-wrapper">
                <div className="field-group">
                  <DropdownComponent
                    label="Product Group is Serialized"
                    placeholder="Product Group is Serialized"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupSerializedEdit}
                    setValue={setProductGroupSerializedEdit}
                  />
                  <DropdownComponent
                    label="Product Group needs IVR"
                    placeholder="Product Group needs IVR"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupIVREdit}
                    setValue={setProductGroupIVREdit}
                  />
                  <DropdownComponent
                    isDisabled={!manufacturerAllowsPayment}
                    label="Collect Payment"
                    placeholder="Collect Payment"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupCollectPaymentEdit}
                    setValue={setProductGroupCollectPaymentEdit}
                  />
                  <DropdownComponent
                    isDisabled={!manufacturerAllowsPayment}
                    label="Enable Open Order"
                    placeholder="Enable Open Order"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupEnableOpenOrderEdit}
                    setValue={setProductGroupEnableOpenOrderEdit}
                  />
                  <DropdownComponent
                    label="Require Procedure Info"
                    placeholder="Require Procedure Info"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupRequireProcedureInfoEdit}
                    setValue={setProductGroupRequireProcedureInfoEdit}
                  />
                  <DropdownComponent
                    label="Signature Required for Delivery"
                    placeholder="Signature Required for Delivery"
                    isRequired
                    options={YES_NO_OPTIONS}
                    value={productGroupSignatureRequiredForDeliveryEdit}
                    setValue={setProductGroupSignatureRequiredForDeliveryEdit}
                  />
                  <DropdownComponent
                    label="Product Group Status"
                    placeholder="Product Group Status"
                    isRequired
                    // isDisabled
                    options={[
                      { label: "Active", value: "yes" },
                      { label: "Inactive", value: "no" },
                    ]}
                    value={productGroupStatusEdit}
                    setValue={setProductGroupStatusEdit}
                  />
                </div>
              </div>
            </div>
            <div className="field-group-wrapper">
              <div className="field-group">
                <OpenOrderImageUpload
                  currentFileName={removeProductGroupOpenOrderImageEdit
                    ? ""
                    : productGroupData?.OpenOrderImageFileName}
                  onClear={removeEditOpenOrderImage}
                  onFileSelect={(file) => handleOpenOrderImageSelect(file, { isEdit: true })}
                  selectedFile={productGroupOpenOrderImageFileEdit}
                />
              </div>
            </div>
            <div className="field-group-wrapper">
              <div className="field-group">
                <DropdownComponent
                  label="Shipping Type"
                  placeholder="Shipping Type"
                  isRequired
                  options={SHIPPING_TYPE_OPTIONS}
                  value={productGroupShippingTypeEdit}
                  setValue={(option) => {
                    setProductGroupShippingTypeEdit(option);
                    if (option?.value !== "custom") {
                      setProductGroupShippingCategoryEdit(null);
                    }
                  }}
                />
              </div>
              {productGroupShippingTypeEdit?.value === "custom" && (
                <div className="field-group-wrapper">
                  <div className="field-group">
                    <DropdownComponent
                      label="Shipping Category"
                      placeholder={getShippingCategoryPlaceholder()}
                      isRequired
                      isDisabled={
                        isShippingCategoriesLoading ||
                        shippingCategoryOptions.length === 0
                      }
                      options={shippingCategoryOptions}
                      value={productGroupShippingCategoryEdit}
                      setValue={setProductGroupShippingCategoryEdit}
                    />
                  </div>
                </div>
              )}
            </div>
            <Text variant="bodyText">Products in this group</Text>
            {isLoadingProducts ? (
              <Text variant="bodyText">Loading products...</Text>
            ) : productsUnderGroup?.length === 0 ? (
              <Text variant="bodyText">
                No products have been added to this product group yet.{" "}
              </Text>
            ) : null}
            {productsUnderGroup?.map((product, index) => {
              return (
                <div className="field-group-wrapper">
                  <div className="field-group-end">
                    <TextInput
                      titleText="Product Name"
                      placeholder="Product Name"
                      value={product?.ProductName}
                      isRequired
                      onChange={(e) =>
                        handleChangeEdit(index, "ProductName", e.target.value)
                      }
                    />
                    <TextInput
                      titleText="Product Code"
                      placeholder="Product Code"
                      value={product?.ProductCode}
                      isRequired
                      onChange={(e) =>
                        handleChangeEdit(index, "ProductCode", e.target.value)
                      }
                    />
                    <TextInput
                      titleText="Units"
                      placeholder="Units"
                      value={product?.Units}
                      isRequired
                      onChange={(e) => {
                        handleChangeEdit(index, "Units", e.target.value);
                        // handleStandardPriceEdit(
                        //   index,
                        //   "standardPrice",
                        //   e.target.value
                        // );
                      }}
                    />
                    <TextInput
                      titleText="Standard Price"
                      placeholder="Standard Price"
                      value={product?.StandardPrice}
                      isRequired
                      isDisabled
                    />
                    {product?.createdAt ? (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => deleteProduct(index)}
                      >
                        <RowIcon type="delete" />
                      </div>
                    ) : (
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() => removeProductEdit(index)}
                      >
                        <RowIcon />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        }
        footerButtonWrapper={
          <div
            style={{ display: "flex", flexDirection: "column", gap: "32px" }}
          >
            <div className="footer-button-wrapper">
              <CommonButton
                variant="table"
                subVariant="primary"
                onClick={addProductEdit}
              >
                Add Product
              </CommonButton>
            </div>
            <div className="footer-button-wrapper">
              <CommonButton
                variant="table"
                subVariant="success"
                onClick={() => submitEditProductGroupHandler("available")}
              >
                Save and Make Available
              </CommonButton>
              <CommonButton
                variant="table"
                subVariant="success"
                onClick={() => submitEditProductGroupHandler("unavailable")}
                >
                Save and Make Unavailable
              </CommonButton>
              {/* <CommonButton
                variant="table"
                subVariant={
                  productGroupStatusEdit === "active" ? "failure" : "success"
                }
                onClick={handleProductGroupStatus}
              >
                {productGroupStatusEdit === "active"
                  ? "Make Inactive"
                  : "Make Active"}
              </CommonButton> */}
            </div>
          </div>
        }
      />

      <ModalView
        isOpen={showProductGroupView}
        onClose={() => setShowProductGroupView(false)}
        modalTitle={productGroupData?.ProductGroupName}
        textInputComponent={
          isLoadingProducts ? (
            <Text variant="bodyText">Loading products...</Text>
          ) : (
            <QuickList
              items={productsUnderGroup}
              emptyItemListErrorText="No products have been added to this product group yet."
              listType="modal"
              primaryTitle="ProductName"
              secondaryTitle="ProductCode"
              // tagKey="IsActive"
              page="Manufacturer"
              price="StandardPrice"
              priceHeader="Units"
              priceHeaderValue="Units"
            />
          )
        }
      />
    </div>
  );
};

export default ManufacturerProduct;
